import React, { useState } from "react";
import "./Gallery.css"; // We'll style with this file

const images = [
  { src: "/imagesevent/event021.jpeg", alt: "Event" },
  { src: "/imagesevent/event022.jpeg", alt: "Event" },
  { src: "/imagesevent/event023.jpeg", alt: "Event" },
  { src: "/imagesevent/event024.jpeg", alt: "Event" },
  { src: "/imagesevent/event025.jpeg", alt: "Event" },
  { src: "/imagesevent/event026.jpeg", alt: "Event" },
  { src: "/imagesevent/event027.jpeg", alt: "Event" },
  { src: "/imagesevent/event028.jpeg", alt: "Event" },
  { src: "/imagesevent/event029.jpeg", alt: "Event" },
  { src: "/imagesevent/event030.jpeg", alt: "Event" },
 
  // Add more images gallery01
];

function Event03() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            onClick={() => setSelectedImg(img.src)}
            className="gallery-image"
          />
        ))}
      </div>

      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} alt="Zoomed" className="lightbox-image" />
        </div>
      )}
    </>
  );
}

export default Event03;
